import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialSettingsState } from '../../models/settingsModel';

export const fetchSettings = createAsyncThunk(
    'settings/fetchSettings',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/Settings/GetSingle');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const settingsSlice = createSlice({
    name: 'settings',
    initialState: initialSettingsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.dataSettings = action.payload;
            })
            .addCase(fetchSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default settingsSlice.reducer;
